import http from '../helpers/http';
import { FilteredOptionsInterface, makeQueryParamsForRequest } from '../entities/FilteredOptions';

const PerformanceDisciplinaryAction = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    create: async (body: any) => {
      const result = await http.post('/disciplinary-action', body, { headers });
      return result.data;
    },
    show: async (id: string) => {
      const result = await http.get(`/disciplinary-action/${id}`, {
        headers,
      });
      return result.data;
    },
    listByEmployee: async (employeeId: string, filteredOptions?: FilteredOptionsInterface) => {
      const params = makeQueryParamsForRequest(filteredOptions);
      const result = await http.get(`/disciplinary-action/by-employee/${employeeId}`, {
        headers,
        params,
      });
      return result.data;
    },
    listBySchool: async (schoolId: string, filteredOptions?: FilteredOptionsInterface) => {
      const params = makeQueryParamsForRequest(filteredOptions);
      const result = await http.get(`/disciplinary-action/by-school/${schoolId}`, {
        headers,
        params,
      });
      return result.data;
    },
    getPriorDiscussions: async (userId: string) => {
      const result = await http.get(`/performance-management/by-user/${userId}`, {
        headers,
      });
      return result.data;
    },
    getUserDisciplinaryActions: async (userId: string, type: string = 'disciplinary-action') => {
      const result = await http.get(`/performance-management/by-user/${userId}`, {
        headers,
        params: { type },
      });
      return result.data;
    },
    approve: async (id: string) => {
      const result = await http.patch(`/disciplinary-action/${id}/approve`, {}, { headers });
      return result.data;
    },
    reject: async (id: string) => {
      const result = await http.delete(`/disciplinary-action/${id}/reject`, { headers });
      return result.data;
    },
    delete: async (id: string) => {
      const result = await http.delete(`/disciplinary-action/${id}`, { headers });
      return result.data;
    },
    update: async (id: string, body: any) => {
      const result = await http.put(`/disciplinary-action/${id}`, body, { headers });
      return result.data;
    },
    listPending: async (schoolId: string) => {
      const result = await http.get(`/disciplinary-action/by-school/${schoolId}/pending`, { headers });
      return result.data?.data ?? result.data ?? [];
    },
    getTemplateDocument: async (id: string): Promise<Blob> => {
      const result = await http.get(`/disciplinary-action/${id}/template-document`, {
        headers,
        responseType: 'blob',
      });
      return result.data;
    },
    finalize: async (id: string, formData: FormData) => {
      const result = await http.patch(`/disciplinary-action/${id}/finalize`, formData, {
        headers: { 'x-access-token': token },
      });
      return result.data;
    },
  };
};

export default PerformanceDisciplinaryAction;
